import * as React from 'react';
import {
  Container,
  Box,
  ListItemText,
  ListSubheader,
  List,
  ListItemButton,
  Typography,
} from '@mui/material';
import fetchCommunities from '../helper-methods/fetchCommunities';
import useStore from '../state-files/zustondStoreStates';
import fetchDiscussions from '../helper-methods/fetchDiscussions';
import CreateCommunityWidget from "./CreateCommunityWidget";
import { apiUrlPrefix } from '../../../config';
import DeleteIcon from '@mui/icons-material/Delete';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Link, useNavigate } from "react-router-dom";
import HeaderBar from '../Components/Static/HeaderBar';
import MobileSidebar from '../Components/Sidebar/MobileSidebar';
import Sidebar from '../Components/Sidebar/Sidebar';

const CommunitiesScreen = () => {
  const { communities, setCommunities } = useStore(); // Use zustand store
  const { setCurrentCommunityName } = useStore(); // Use zustand store
  const { setCurrentCommunityId, setCommunityId, setIsCommunityAdmin } = useStore(); // Use zustand store
  const setDiscussions = useStore((state) => state.setDiscussions);
  const [currentUser] = React.useState(localStorage.getItem('userId'));
  const [removedCommunities, setRemovedCommunities] = React.useState({});
  const navigate = useNavigate();

  // Async function to fetch a list of discussions within the community
  const fetchChatMessages = async (communityId, communityName) => {
    setCommunityId(communityId);
    setCurrentCommunityName(communityName);
    fetchDiscussions(setDiscussions, communityId);
    setCurrentCommunityId(communityId);

    navigate('/discussions');
  };

  const deleteCommunity = async ({ communityId }) => {
    const apiUrl = apiUrlPrefix + `Communities/RemoveCommunity/${communityId}`;
    const response = await fetch(apiUrl, {
      method: 'Delete',
      credentials: 'include', // Include cookies in request
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.ok) {
      return response.status;
    } else if (response.status === 304 || response.status === 400) {
      return 304; //It is not modified
    }
  }


  return (
    <Box
      sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
    >
      <HeaderBar isLoggedIn={true} />
      <Box sx={{ display: 'flex', gap: 3, justifyContent: 'flex-start' }}>
        <Sidebar />
        <MobileSidebar />
        
        <Container sx={{ paddingTop: { xs: 2 } }}>
          <List
            sx={{ width: '100%', bgcolor: 'background.paper' }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
              <ListSubheader component="div" id="nested-list-subheader"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  py: 1,
                  borderBottom: '1px solid #eee'
                }}>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  Communities
                </Typography>


                <Typography variant="subtitle1" sx={{
                  fontWeight: 'bold', border: '1px solid black',
                  fontWeight: 'bold', border: '1px solid black', borderRadius: '10px',            // 1. Glossy Gradient (Light Green to Primary Green)
                  background: 'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(40, 165, 52, 0.5) 100%)',
                  backgroundColor: 'rgba(129, 199, 132, 0.5)', // The "Lighter" base color

                  // 2. Glassmorphism Effects
                  backdropFilter: 'blur(4px)', // Softens the background behind the button
                  border: '1px solid rgba(255, 255, 255, 0.3)', // Soft white border for depth

                  // 3. Shadow for "Pop"
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

                  // 4. Text Styling
                  color: 'white', // Darker green text for readability
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  borderRadius: '12px',
                  px: 0.2,
                  py: 0.1,

                  transition: 'all 0.3s ease',
                  '&:hover': {
                    background: 'linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(40, 165, 52, 0.4) 100%)',
                    transform: 'translateY(-1px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                  }
                }}>
                  <CreateCommunityWidget isBold={true} />
                </Typography>
              </ListSubheader>
            }
          >
            {communities.map((community, index) => {
              const isChatAdmin = community?.admins?.includes(currentUser);
              const wantsToDeleteDiscussion = removedCommunities[community.id];
              return (
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', gap: 3 }}>
                  <ListItemButton key={index}>
                    <ListItemText id={community.id}
                      primary={community.name || "Unknown"}
                      onClick={() => {
                        setIsCommunityAdmin(isChatAdmin);
                        navigate('/discussions');
                        fetchChatMessages(community.id, community.name)
                      }}
                    />
                  </ListItemButton>
                  <Typography component={Link} to="/moderationPanel" sx={{ display: isChatAdmin ? 'flex' : 'none', color: 'blue', cursor: 'pointer' }} onClick={() => {
                  }}><ManageAccountsIcon /></Typography>
                  <Typography sx={{ display: isChatAdmin ? 'flex' : 'none', color: 'red', pr: 3, cursor: 'pointer' }} onClick={() => {
                    if (!wantsToDeleteDiscussion) {
                      setRemovedCommunities(prev => ({
                        ...prev,
                        [community.id]: true //Mark this as wanting to delete
                      }));
                      return;
                    } else {
                      // Inside your delete function
                      deleteCommunity({ communityId: community.id }); //Remove the community from the server

                      const newCommunities = communities.filter((communities) => communities.id !== community.id);

                      // Use the functional update to ensure you have the current state
                      setCommunities(newCommunities);
                    }
                  }}>{(wantsToDeleteDiscussion) ? "Confirm" : <DeleteIcon />}</Typography>
                </Box>
              );
            })}
          </List>
        </Container>
      </Box>

    </Box>
  );
};

export default CommunitiesScreen;
